import { useTranslation } from '@gem/modules/i18n';

import { spaceMarketLinkValidation, spaceMarketNameValidation } from '../fields/fields';
import type { IFormFieldValidation, IValidateParams, ValidationResult } from '../hooks';
import { useAsyncValidation, useSyncValidation } from '../hooks';
import { ValidationErrorType } from '../validation.types';

export interface ISpaceMarketLinkAsyncDeps {
  spaceMarketLinkAsyncValidation: (params: IValidateParams) => Promise<string | null>;
}

export interface ISpaceMarketValidations {
  marketName: IFormFieldValidation;
  marketLink: IFormFieldValidation;
}

export const useSharedSpaceMarketValidations = (
  deps: ISpaceMarketLinkAsyncDeps
): ISpaceMarketValidations => {
  const { t } = useTranslation();

  const nameErrorToText = {
    [ValidationErrorType.Empty]: ' ',
    [ValidationErrorType.TooShort]: t('market_name_min_length_error'),
  };

  const linkErrorToText = {
    [ValidationErrorType.Empty]: ' ',
    [ValidationErrorType.Invalid]: t('market_link_invalid_error'),
  };

  const nameValidator = useSyncValidation();
  const linkValidator = useAsyncValidation();

  return {
    marketName: {
      validate: (value, _formData, meta): ValidationResult => {
        return nameValidator({
          value,
          meta: meta!,
          validate: spaceMarketNameValidation,
          errorToText: nameErrorToText,
        });
      },
    },
    marketLink: {
      validate: (value, _formData, meta): ValidationResult => {
        return linkValidator({
          value,
          meta: meta!,
          validate: spaceMarketLinkValidation,
          asyncValidate: deps.spaceMarketLinkAsyncValidation,
          errorToText: linkErrorToText,
        });
      },
    },
  };
};
